<template>
    <component :is="component">
        <slot/>
    </component>
</template>

<style>
    @font-face {
        font-family: 'regularFont';
        src: url('./assets/fonts/neris-light.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldFont';
        src: url('./assets/fonts/neris-black.otf') format('opentype');
        font-weight: bold;
    }

    .application {
        font-family: regularFont;
        background-color: transparent !important;
        font-size: 14px;
    }

    .app-error-info {
        font-size: 14px;
        color: #888;
        text-align: center;
        padding: 20px;
    }

    .app-error-info>div {
        margin-top: 5px;
    }
</style>

<script>
    import VuebaseLayout from './layouts/VuebaseLayout'
    import Utils from './services/Utils'

    export default {
        name: 'App',
        components: {
            VuebaseLayout
        },
        computed: {
            component() {
                return VuebaseLayout
            }
        },
        beforeMount: function () {
            Utils.initialize()
        }
    }
</script>
